import React from 'react';
import { Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { timeAgo } from '../../utils/mappers';
import useWindowSize from '../../hooks/useWindowSize';
const CardAnalises = ({ newsItem }) => {
  const history = useHistory();
  const size = useWindowSize();
  const handleCardClick = (event) => {
    if (event.target.closest('a')) {
      event.stopPropagation(); // Só impede a propagação do evento
    } else {
      history.push(`/analise/${newsItem.slug}`);
    }
  };

  return (
    <Col xs={12} sm={6} md={4} lg={4} xl={3} style={{ marginBottom: '30px' }}>
      <div
        onClick={handleCardClick}
        className="news-card-overlay"
        style={{ cursor: 'pointer', position: 'relative', borderRadius: '10px', overflow: 'hidden' }}
      >
        <img
          src={newsItem.image_url}
          alt={newsItem.name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',

          }}
        />

        {/* CATEGORIA OU TAG */}
        {newsItem.categoryName && (
          <span className="badge badge-primary" style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            fontSize: '12px'
          }}>
            {newsItem.categoryName}
          </span>
        )}

        {/* SOBREPOSIÇÃO DE TEXTO */}
        <div className="news-overlay-text">
          <h5 className="overlay-title">{newsItem.name}</h5>
          <p className="overlay-footer">
            {new Date(newsItem.created_at).toLocaleDateString()} &nbsp;|&nbsp; {new Date(newsItem.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </p>
        </div>
      </div>
    </Col >
  );
};

export default CardAnalises;
